module.exports = __webpack_public_path__ + "static/media/final-jeopardy.fc9f29fa.jpg";